import { IconNames } from "@blueprintjs/icons";

import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import UrlUtil from "core/util/UrlUtil";
import { ILinkType, LinkTypeRegistry } from "../ILinkType";


const CurrentPageContainerLink: ILinkType<void> = {
	type: "currentpage",
	label: "Current Page Container",
	icon: IconNames.PAGE_LAYOUT,
	mapDataToMenuNode: (_, props, state) => {

		const active = UrlUtil.getActivePageInstance(state);

		const panel = active ? state.config.panels[active] : null;

		return {
			...props,
			isSelectable: false,
			label: panel ? <Label k={`panel.${active}.title`} v={panel.title} /> : "Nothing?",
			icon: panel && panel.icon ? <Icon icon={panel.icon} /> : null
		};
	}
};

export default LinkTypeRegistry.registerType(CurrentPageContainerLink);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/CurrentPageContainerLink.tsx